var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationMoneyBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M26 34h2v-2h-2zM22 34h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 38H16v-2h14V18H12v-2h18c1.103 0 2 .897 2 2v18c0 1.103-.897 2-2 2M58 28h-3v-2h3c.551 0 1-.448 1-1v-1c0-.552-.449-1-1-1h-3v-2h3c1.654 0 3 1.346 3 3v1c0 1.654-1.346 3-3 3",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 33h-3v-2h3c.551 0 1-.448 1-1v-1c0-.552-.449-1-1-1v-2c1.654 0 3 1.346 3 3v1c0 1.654-1.346 3-3 3M34 20h-3v-2h2.586l5.707-5.707a.998.998 0 01.511-.273l5-1 .392 1.96-4.703.941-5.786 5.786A.997.997 0 0134 20",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.781 16h4.438l1.5-6h-7.438l1.5 6zM53 18h-6a.999.999 0 01-.97-.758l-2-8A.998.998 0 0145 8h10a.998.998 0 01.97 1.242l-2 8A.999.999 0 0153 18zM49 72c-11.542 0-19-6.28-19-16 0-5.927 3.967-10.641 7.467-14.8 1.439-1.71 2.799-3.326 3.67-4.807l1.724 1.013c-.957 1.627-2.369 3.305-3.864 5.082C35.717 46.386 32 50.803 32 56c0 10.333 9.158 14 17 14 7.842 0 17-3.667 17-14 0-5.198-3.719-9.616-7-13.515-1.495-1.775-2.907-3.453-3.864-5.08l1.724-1.013c.872 1.481 2.231 3.096 3.67 4.805C64.032 45.357 68 50.072 68 56c0 9.72-7.458 16-19 16",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 45c3.523 0 6.565 2.029 8.043 4.978l-1.788.894A6.992 6.992 0 0049 47a7 7 0 00-6.326 4H48v2h-5.93a7.06 7.06 0 00.001 2.001L48 55v2h-5.326A7 7 0 0049 61a6.993 6.993 0 006.256-3.872l1.787.893C55.565 60.971 52.523 63 49 63a9.003 9.003 0 01-8.488-6H38v-2h2.055a9.101 9.101 0 010-2H38v-2h2.512A9.003 9.003 0 0149 45z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 38H44a.998.998 0 01-.243-.03L35.877 36H31v-2h5c.082 0 .163.01.243.03l7.88 1.97H56c.551 0 1-.448 1-1v-1c0-.552-.449-1-1-1v-2c1.654 0 3 1.346 3 3v1c0 1.654-1.346 3-3 3M57 23v-2c.551 0 1-.448 1-1v-1c0-.552-.449-1-1-1H44v-2h13c1.654 0 3 1.346 3 3v1c0 1.654-1.346 3-3 3",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationMoneyBag;